// import CardsAK from '../assets/images/turbo-belote/cards-a-k.png';
import Cards100 from '../assets/images/turbo-belote/cards-100.png';
// import CardsDoubleTierce from '../assets/images/turbo-belote/cards-double-tierce.png';
import CardsA from '../assets/images/turbo-belote/cards-7.png';
import Cards50 from '../assets/images/turbo-belote/cards-50.png';
import CardsTierce from '../assets/images/turbo-belote/cards-tierce.png';
import pikes7 from '../assets/images/turbo-belote/cards-belote/pikes_7.png';
import pikes8 from '../assets/images/turbo-belote/cards-belote/pikes_8.png';
import pikes9 from '../assets/images/turbo-belote/cards-belote/pikes_9.png';
import pikes10 from '../assets/images/turbo-belote/cards-belote/pikes_10.png';
import pikesJ from '../assets/images/turbo-belote/cards-belote/pikes_J.png';
import pikesQ from '../assets/images/turbo-belote/cards-belote/pikes_Q.png';
import pikesK from '../assets/images/turbo-belote/cards-belote/pikes_K.png';
import pikesA from '../assets/images/turbo-belote/cards-belote/pikes_A.png';

import heart7 from '../assets/images/turbo-belote/cards-belote/heart_7.png';
import heart8 from '../assets/images/turbo-belote/cards-belote/heart_8.png';
import heart9 from '../assets/images/turbo-belote/cards-belote/heart_9.png';
import heart10 from '../assets/images/turbo-belote/cards-belote/heart_10.png';
import heartJ from '../assets/images/turbo-belote/cards-belote/heart_J.png';
import heartQ from '../assets/images/turbo-belote/cards-belote/heart_Q.png';
import heartK from '../assets/images/turbo-belote/cards-belote/heart_K.png';
import heartA from '../assets/images/turbo-belote/cards-belote/heart_A.png';

import diamonds7 from '../assets/images/turbo-belote/cards-belote/diamonds_7.png';
import diamonds8 from '../assets/images/turbo-belote/cards-belote/diamonds_8.png';
import diamonds9 from '../assets/images/turbo-belote/cards-belote/diamonds_9.png';
import diamonds10 from '../assets/images/turbo-belote/cards-belote/diamonds_10.png';
import diamondsJ from '../assets/images/turbo-belote/cards-belote/diamonds_J.png';
import diamondsQ from '../assets/images/turbo-belote/cards-belote/diamonds_Q.png';
import diamondsK from '../assets/images/turbo-belote/cards-belote/diamonds_K.png';
import diamondsA from '../assets/images/turbo-belote/cards-belote/diamonds_A.png';

import clover7 from '../assets/images/turbo-belote/cards-belote/clover_7.png';
import clover8 from '../assets/images/turbo-belote/cards-belote/clover_8.png';
import clover9 from '../assets/images/turbo-belote/cards-belote/clover_9.png';
import clover10 from '../assets/images/turbo-belote/cards-belote/clover_10.png';
import cloverJ from '../assets/images/turbo-belote/cards-belote/clover_J.png';
import cloverQ from '../assets/images/turbo-belote/cards-belote/clover_Q.png';
import cloverK from '../assets/images/turbo-belote/cards-belote/clover_K.png';
import cloverA from '../assets/images/turbo-belote/cards-belote/clover_A.png';

import AK4Cards from '../assets/images/turbo-belote/new-combination-big-plus/A+K-4Cards.png';
import A450BlacK from '../assets/images/turbo-belote/new-combination-big-plus/4A-50BlacK.png';
import K50Red50 from '../assets/images/turbo-belote/new-combination-big-plus/K50-Red50.png';
import A100TierceRed from '../assets/images/turbo-belote/new-combination-big-plus/A100-tierceRed.png';
import A4TierceRed from '../assets/images/turbo-belote/new-combination-big-plus/A4-TierceRed.png';
import K50TierceRed from '../assets/images/turbo-belote/new-combination-big-plus/K50-TierceRed.png';
import TierceRedTierceBlack from '../assets/images/turbo-belote/new-combination-big-plus/TierceRed-TierceBlacK.png';

export const COMBINATIONS_PAYOUTS = [
  {
    winType: 11,
    // img: CardsAK,
    img: AK4Cards,
    type: '4_CARDS_DOUBLE',
    odd: 5000,
  },
  {
    winType: 10,
    img: A450BlacK,
    type: '4_CARDS_50',
    odd: 2500,
  },
  {
    winType: 9,
    img: K50Red50,
    type: '50_50',
    odd: 1000,
  },
  {
    winType: 7,
    img: A100TierceRed,
    type: '100_TIERCE',
    odd: 500,
  },
  {
    winType: 8,
    img: A4TierceRed,
    type: '4_CARDS_TIERCE',
    odd: 100,
  },
  {
    winType: 6,
    img: K50TierceRed,
    type: '50_TIERCE',
    odd: 50,
  },
  {
    winType: 3,
    img: Cards100,
    type: '100',
    odd: 25,
  },
  {
    winType: 5,
    img: TierceRedTierceBlack,
    type: 'TIERCE_TIERCE',
    odd: 15,
  },
  {
    winType: 4,
    img: CardsA,
    type: '4_CARDS',
    odd: 10,
  },
  {
    winType: 2,
    img: Cards50,
    type: '50',
    odd: 5,
  },
  {
    winType: 1,
    img: CardsTierce,
    type: 'TIERCE',
    odd: 2,
  },
];

export const CARDS_TYPE = {
  0: 'pikes_7',
  1: 'pikes_8',
  2: 'pikes_9',
  3: 'pikes_10',
  4: 'pikes_J',
  5: 'pikes_Q',
  6: 'pikes_K',
  7: 'pikes_A',

  8: 'heart_7',
  9: 'heart_8',
  10: 'heart_9',
  11: 'heart_10',
  12: 'heart_J',
  13: 'heart_Q',
  14: 'heart_K',
  15: 'heart_A',

  16: 'diamonds_7',
  17: 'diamonds_8',
  18: 'diamonds_9',
  19: 'diamonds_10',
  20: 'diamonds_J',
  21: 'diamonds_Q',
  22: 'diamonds_K',
  23: 'diamonds_A',

  24: 'clover_7',
  25: 'clover_8',
  26: 'clover_9',
  27: 'clover_10',
  28: 'clover_J',
  29: 'clover_Q',
  30: 'clover_K',
  31: 'clover_A',

  32: 'UNKNOWN',
};

export const MAX_CARDS_COUNT_IN_TABLE = 8;

export const CARDS_BOX = new Array(MAX_CARDS_COUNT_IN_TABLE).fill(null);

export const HISTORY_CARDS = {
  pikes_7: pikes7,
  pikes_8: pikes8,
  pikes_9: pikes9,
  pikes_10: pikes10,
  pikes_J: pikesJ,
  pikes_Q: pikesQ,
  pikes_K: pikesK,
  pikes_A: pikesA,

  heart_7: heart7,
  heart_8: heart8,
  heart_9: heart9,
  heart_10: heart10,
  heart_J: heartJ,
  heart_Q: heartQ,
  heart_K: heartK,
  heart_A: heartA,

  diamonds_7: diamonds7,
  diamonds_8: diamonds8,
  diamonds_9: diamonds9,
  diamonds_10: diamonds10,
  diamonds_J: diamondsJ,
  diamonds_Q: diamondsQ,
  diamonds_K: diamondsK,
  diamonds_A: diamondsA,

  clover_7: clover7,
  clover_8: clover8,
  clover_9: clover9,
  clover_10: clover10,
  clover_J: cloverJ,
  clover_Q: cloverQ,
  clover_K: cloverK,
  clover_A: cloverA,
};
